'use client';

import { useRef } from 'react';

import { cn } from '@/lib/utils';

import { ServiceStatusProps } from '@/decodo/components/atoms/Instatus/index';
import { ServiceStatusIcon } from '@/decodo/components/atoms/Instatus/StatusIcon';

import LinkButton from '@/decodo/components/atoms/LinkButton';
import { Spinner } from '@/decodo/components/atoms/spinner';
import { Text } from '@/decodo/components/atoms/Text';
import { Tooltip } from '@/decodo/components/atoms/Tooltip/Tooltip';

const DECODO_INSTATUS = 'https://status.decodo.com';

export const ServiceStatusComponent = ({
  message,
  classNames,
  size,
  status,
}: {
  message: string;
  status: 'success' | 'error' | 'loading';
  classNames?: ServiceStatusProps['classNames'];
  size?: ServiceStatusProps['size'];
}) => {
  const textContainerRef = useRef<HTMLDivElement>(null);

  const maxTextWidth: number | undefined = textContainerRef?.current
    ?.clientWidth
    ? textContainerRef?.current?.clientWidth - 8
    : undefined;

  return (
    <Tooltip text={message} classNames={classNames?.tooltip}>
      <LinkButton
        data-tracker-context='service-status'
        href={DECODO_INSTATUS}
        target='_blank'
        classNames={{
          inner: 'w-full',
        }}
        className={cn(
          'flex w-full flex-row overflow-hidden rounded border border-gray-700 align-middle',
          size === 'sm' ? 'p-2' : 'p-4',
          classNames?.button
        )}
      >
        {status === 'loading' ? (
          <Spinner />
        ) : (
          <ServiceStatusIcon status={status} />
        )}
        <div ref={textContainerRef} className='block w-full flex-1'>
          <Text
            className={cn(
              // NOTE: when editing paddings here, adjust maxTextWidth accordingly
              'text-button-text-s ml-2 max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-serif',
              size === 'sm' ? 'text-body-s' : 'text-body-m',
              classNames?.text
            )}
            color='base-black'
            style={{ maxWidth: maxTextWidth }}
          >
            {message}
          </Text>
        </div>
      </LinkButton>
    </Tooltip>
  );
};
